import {
  SetFrame as timeframeSetFrame,
  ResetFrame as timeframeResetFrame,
  SetWriter as timeframeSetWriter,
  AdminMethods as TimeframeAdminMethods,
} from './admin';
import {
  GetEnd as timeframeGetEnd,
  GetStart as timeframeGetStart,
  GetFrame as timeframeGetFrame,
  GetterMethods as TimeframeUserMethods,
} from './getters';

const NamedAdminMethods = {
  timeframeSetFrame,
  timeframeResetFrame,
  timeframeSetWriter,
};
const NamedUserMethods = {
  timeframeGetEnd,
  timeframeGetStart,
  timeframeGetFrame,
};

export const TimeframeMethods = {
  ...NamedAdminMethods,
  ...NamedUserMethods,
}
export {
  TimeframeAdminMethods,
  TimeframeUserMethods
};
export default TimeframeMethods;